export const TYPES = {
  ADD_STATE: "setting/ADD_STATE",
  GET_FORM_STRUCTURE_BY_ID: "setting/GET_FORM_STRUCTURE_BY_ID",
  SET_FORM_STRUCTURE_BY_ID: "setting/SET_FORM_STRUCTURE_BY_ID",
  MODIFY_FORM_STRUCTURE_BY_ID: "configuration/MODIFY_FORM_STRUCTURE_BY_ID"
};
